const MAX_STEMS = 10
const MIN_STEM_LENGTH = 4

// Words that sit in half of any backlog's titles, so they rank nothing.
const GENERIC_STEMS = new Set([
	"issue",
	"feature",
	"request",
	"problem",
	"error",
	"help",
	"question",
	"thank",
	"support",
	"customer",
	"user",
	"please",
	"would",
	"could",
	"should",
	"about",
	"with",
	"that",
	"this",
	"have",
	"from",
	"when",
	"what",
])

// "suggestions", "suggested" and "suggest" must all find "Suggest similar issues".
export function stemWord(word: string): string {
	const cut = (n: number) =>
		word.length - n >= MIN_STEM_LENGTH ? word.slice(0, -n) : word
	if (word.endsWith("ions")) return cut(4)
	if (word.endsWith("ion")) return cut(3)
	if (word.endsWith("ings")) return cut(4)
	if (word.endsWith("ing")) return cut(3)
	if (word.endsWith("ies")) return cut(3)
	if (word.endsWith("ed")) return cut(2)
	if (/(ss|sh|ch|x|z)es$/.test(word)) return cut(2)
	if (word.endsWith("s") && !word.endsWith("ss")) return cut(1)
	return word
}

/** Distinct word stems from search terms, longest first. */
export function searchStems(terms: readonly string[]): string[] {
	const stems = new Set<string>()
	for (const term of terms) {
		for (const word of term.toLowerCase().split(/[^\p{L}\p{N}]+/u)) {
			if (word.length < MIN_STEM_LENGTH) continue
			const stem = stemWord(word)
			if (stem.length >= MIN_STEM_LENGTH && !GENERIC_STEMS.has(stem))
				stems.add(stem)
		}
	}
	return [...stems].sort((a, b) => b.length - a.length).slice(0, MAX_STEMS)
}
